import { useMutation, useQueryClient } from '@tanstack/react-query';

import { $api, errorHandler, globalConst } from 'modules/global';

export function useCheckThemedTest() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ testId, optionId }: { testId?: number; optionId?: number | null }) => {
      const { data } = await $api.post(`/check-test`, { id: testId, option_id: optionId });

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [globalConst.queryKeys.GET_HEART_XP_DATA] });
    },
    onError: errorHandler()
  });
}
